/**
 * Success Overlay - Breathing Pulse Micro-Interaction
 * Wellness-aligned animation that mimics calm breathing
 * Shows booking success with a serene, meditative feel
 */
import React, { useEffect } from 'react';
import { Check } from 'lucide-react';

export default function SuccessOverlay({ message, isVisible, onClose, duration = 3000 }) {
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center pointer-events-none">
      {/* Soft backdrop with fade */}
      <div className="absolute inset-0 bg-black/15 animate-fade-in backdrop-blur-sm" />
      
      {/* Success container */}
      <div className="relative flex flex-col items-center animate-success-pop">
        
        {/* Breathing Pulse Rings */}
        <div className="relative w-36 h-36 flex items-center justify-center mb-6">
          {/* Outer breathing ring - slowest */}
          <div className="absolute inset-0 rounded-full bg-primary/20 animate-breathe-outer" />
          
          {/* Middle breathing ring */}
          <div className="absolute inset-4 rounded-full bg-primary/25 animate-breathe-middle" />
          
          {/* Inner breathing ring - fastest */}
          <div className="absolute inset-8 rounded-full bg-primary/30 animate-breathe-inner" />
          
          {/* Center circle with checkmark */}
          <div className="relative w-16 h-16 rounded-full bg-primary flex items-center justify-center shadow-lg shadow-primary/30 animate-breathe-center">
            <Check className="w-8 h-8 text-white stroke-[3]" />
          </div>
        </div>
        
        {/* Success message card */}
        <div className="bg-white/95 backdrop-blur rounded-2xl shadow-xl px-8 py-4 mx-4 max-w-sm animate-slide-up delay-200">
          <p className="text-lg font-heading text-foreground text-center">
            {message}
          </p>
          <p className="text-sm text-muted-foreground text-center mt-1">
            Your spot is secured
          </p>
        </div>
      </div>
    </div>
  );
}
